import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../assets/Navbar/CINNAMON MANTRA (1).png';
import backgroundImage from '../assets/Navbar/pexels-fwstudio-33348-172289.jpg';
import { FaRegEnvelope, FaWhatsapp, FaInstagram } from 'react-icons/fa';
import { LuPhone } from 'react-icons/lu';
import { SlLocationPin } from 'react-icons/sl';
import { IoLogoFacebook } from 'react-icons/io5';
import { GiHamburgerMenu } from 'react-icons/gi';
import { FaTiktok } from 'react-icons/fa';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div>
            {/* Top Section */}
            <div
                className={`d-flex align-items-center justify-content-between text-white ${isScrolled ? 'shadow-sm' : ''}`}
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '200px',
                    borderBottom: '5px solid #808080',
                    padding: '0 20px',
                    position: 'relative',
                }}
            >
                {/* Centered Logo */}
                <div
                    className="d-flex justify-content-center w-100 mt-2"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        '@media (maxWidth: 768px)': { // Updated to camelCase
                            left: '20px',
                            transform: 'translate(0, -50%)',
                        },
                    }}
                >
                    <img src={logo} alt="Cinnamon Mantra" style={{ height: '220px' }} />
                </div>

                {/* Social Icons in Top Right Corner */}
                <div className="d-none d-md-flex gap-2" style={{ position: 'absolute', top: '150px', right: '20px' }}>
                    <a href="tel:+94769072745" className="text-white">
                        <LuPhone size={25} />
                    </a>
                    <a href="https://maps.app.goo.gl/oZJCsCD6mAfLcgUYA" className="text-white" target="_blank" rel="noopener noreferrer">
                        <SlLocationPin size={25} />
                    </a>
                    <a href="mailto:cinnamonmantra@gmail.com" className="text-white">
                        <FaRegEnvelope size={25} />
                    </a>
                    <a href="https://web.facebook.com/profile.php?id=61573172313018" className="text-white" target="_blank" rel="noopener noreferrer">
                        <IoLogoFacebook size={25} />
                    </a>
                    <a href="https://wa.me/+94769072745" className="text-white" target="_blank" rel="noopener noreferrer">
                        <FaWhatsapp size={25} />
                    </a>
                    <a href="https://www.instagram.com/cinnamon_mantra/" className="text-white" target="_blank" rel="noopener noreferrer">
                        <FaInstagram size={25} />
                    </a>
                    <a href="https://www.tiktok.com/@cinnamon_mantra?lang=en" className="text-white" target="_blank" rel="noopener noreferrer">
                        <FaTiktok size={25} />
                    </a>
                </div>

                {/* Menu Button for Mobile */}
                <div className="d-md-none" style={{ position: 'absolute', top: '150px', right: '20px' }}>
                    <button className="btn text-white" onClick={toggleMenu}>
                        <GiHamburgerMenu size={30} />
                    </button>
                </div>
            </div>

            {/* Bottom Section */}
            <div
                className="d-none d-md-flex justify-content-between align-items-center px-4 py-2"
                style={{
                    backgroundColor: 'white',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    boxShadow: isScrolled ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'none',
                }}
            >
                {/* Centered Navigation Links */}
                <div className="d-flex justify-content-center flex-grow-1">
                    <ul className="nav mb-0" style={{ fontFamily: 'Copperplate, serif', fontSize: '25px', marginLeft: '100px' }}>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                })}
                            >
                                Home
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/villa"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                })}
                            >
                                Villa
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/ayurveda-spa"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                })}
                            >
                                Ayurveda Spa
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/about-us"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                })}
                            >
                                About Us
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/gallery"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                })}
                            >
                                Gallery
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/contact-us"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                })}
                            >
                                Contact Us
                            </NavLink>
                        </li>
                    </ul>
                </div>

                {/* Book Now Button */}
                <div className="d-flex align-items-center gap-3">
                    <NavLink to="/booking" className="btn btn-success">Book Now</NavLink>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div
                    className="d-md-none"
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        height: '100vh',
                        width: '100%',
                        backgroundColor: 'white',
                        boxShadow: '-2px 0 5px rgba(0, 0, 0, 0.1)',
                        zIndex: 1001,
                        padding: '20px',
                        left: '30px',
                    }}
                >
                    <button className="btn text-dark fw-bold mb-3" style={{ marginTop: '200px', marginLeft: '250px', fontSize: '2em' }} onClick={toggleMenu}>
                        X
                    </button>
                    <ul className="nav flex-column">
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                    marginLeft: '100px',
                                })}
                            >
                                Home
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/villa"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                    marginLeft: '100px',
                                })}
                            >
                                Villa
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/ayurveda-spa"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                    marginLeft: '100px',
                                })}
                            >
                                Ayurveda Spa
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/about-us"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                    marginLeft: '100px',
                                })}
                            >
                                About Us
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/gallery"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                    marginLeft: '100px',
                                })}
                            >
                                Gallery
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className="nav-link text-dark"
                                to="/contact-us"
                                style={({ isActive }) => ({
                                    textDecoration: isActive ? 'underline' : 'none',
                                    marginLeft: '100px',
                                })}
                            >
                                Contact Us
                            </NavLink>
                        </li>
                        {/* Add the Book Now button here */}
                        <li className="nav-item">
                            <NavLink
                                to="/booking"
                                className="btn btn-success"
                                style={{ marginLeft: '100px', marginTop: '20px' }}
                            >
                                Book Now
                            </NavLink>
                        </li>
                    </ul>
                    <div className="d-flex gap-2 mt-3" style={{ marginLeft: '50px' }}>
                        <a href="tel:+94769072745" className="text-dark">
                            <LuPhone size={25} />
                        </a>
                        <a href="https://maps.app.goo.gl/oZJCsCD6mAfLcgUYA" className="text-dark" target="_blank" rel="noopener noreferrer">
                            <SlLocationPin size={25} />
                        </a>
                        <a href="mailto:cinnamonmantra@gmail.com" className="text-dark">
                            <FaRegEnvelope size={25} />
                        </a>
                        <a href="https://web.facebook.com/profile.php?id=61573172313018" className="text-dark" target="_blank" rel="noopener noreferrer">
                            <IoLogoFacebook size={25} />
                        </a>
                        <a href="https://wa.me/+94769072745" className="text-dark" target="_blank" rel="noopener noreferrer">
                            <FaWhatsapp size={25} />
                        </a>
                        <a href="https://www.instagram.com/cinnamon_mantra/" className="text-dark" target="_blank" rel="noopener noreferrer">
                            <FaInstagram size={25} />
                        </a>
                        <a href="https://www.tiktok.com/@cinnamon_mantra?lang=en" className="text-dark" target="_blank" rel="noopener noreferrer">
                            <FaTiktok size={25} />
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Navbar;